import React, { useContext, useState } from "react";
import Logo from "../../Assets/logo/vizi_logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { StoreContext } from "../../store/Store";

const Header = ({ isLoggedIn = true }) => {
  // Added isLoggedIn prop
  const { logout, userid, sidebarActive, setUserid } = useContext(StoreContext);
  const [showDropdown, setShowDropdown] = useState(false);

  const location = useLocation();

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  console.log(userid);

  const navigate = useNavigate();
  function handleLogout() {
    logout();
    setUserid(null);
    navigate("/sign-in");
  }

  return (
    <>
      {/* Header */}
      <header>
        <div className="container-fluid">
          <div className="row d-flex align-items-center">
            <div className="col-4">
              <Link to="/" className="logo">
                <img
                  src={"/assets/logo/cloocus.png"}
                  alt="Logo"
                  className="img-fluid"
                  width="95"
                />
                {/* {userid && (
                  <img
                    src={
                      userid == 132
                        ? "/assets/logo/cloocus.png"
                        : userid == undefined
                        ? ""
                        : "/assets/logo/vizi_logo.png"
                    }
                    alt="Logo"
                    className="img-fluid"
                    width="95"
                  />
                )} */}
                {/* {location.pathname === "/sign-in" ? (
                  <img
                    src="/assets/logo/cloocus.png"
                    alt="Logo"
                    className="img-fluid"
                    width="95"
                  />
                ) : (
                  ""
                )} */}
              </Link>
            </div>
            <div className="col-4 text-center">
              <button
                className="btn_nav d-none"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasNav"
              >
                <i className="bi bi-list"></i>
              </button>
            </div>
            <div className="col-4">
              <div id="social">
                <>
                  {/* <ul className="list-unstyled d-none d-lg-flex justify-content-end mb-0 gap-3">
                    <Link to="/login" className="btn btn-dark text-sm btn-text rounded-pill" style={{padding:"6px 12px"}}>
                        Log in
                      </Link>
                      <Link to="#" className="btn border btn-text rounded-pill" style={{padding:"6px 12px"}}>
                        Sign up
                      </Link>
                    {localStorage.getItem("userid") ? (
                      <button
                        className="btn btn-dark text-sm btn-text rounded-pill"
                        style={{ padding: "6px 12px" }}
                        onClick={handleLogout}
                      >
                        Log out
                      </button>
                    ) : (
                      <></>
                    )}
                  </ul> */}
                  {/* <button
                      className="btn_nav btn d-block d-lg-none"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasNav"
                    >
                      <i className="bi bi-list fs-5"></i>
                    </button> */}
                </>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Offcanvas Navigation */}
      {/* <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="offcanvasNav"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul>
            <li>
              <a href="index.html" className="animated_link">
                Test I
              </a>
            </li>
            <li>
              <a
                href="reservation-single-date-picker.html"
                className="animated_link"
              >
                Test II
              </a>
            </li>
            <li>
              <a
                href="reservation-range-date-picker-lang.html"
                className="animated_link"
              >
                Test III
              </a>
            </li>
            {isLoggedIn ? (
              <>
                <li>
                  <Link to="/profile" className="animated_link">
                    Profile
                  </Link>
                </li>
                <li>
                  <button 
                    className="btn btn-dark text-sm btn-text rounded-pill w-100"
                    onClick={handleLogout}
                  >
                    Logout
                  </button>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/login" className="btn btn-dark text-sm btn-text rounded-pill w-100">
                    Log in
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="btn border btn-text rounded-pill w-100">
                    Sign up
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div> */}
    </>
  );
};

export default Header;
